import React from "react";
import Button from "../Button/Button";
import { CrashIcon } from "../../assets/assets";
import "./ErrorBoundary.css";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(_error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.error(error, errorInfo);
    this.props.handleComponentDidCatch(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <main className="inherit-parent-height inherit-parent-width display-flex flex-direction-column flex-align-items-center flex-justify-content-center padding-larger text-align-center">
          <div
            style={{
              width: 72,
              height: 72,
              borderRadius: "50%",
              background: "#fef3f2",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: 20
            }}
          >
            <CrashIcon />
          </div>
          <div className="font-family-gilroy-medium font-size-large font-color-secondary margin-bottom-small">
            Something broke
          </div>
          <div
            className="font-color-secondary font-size-small margin-bottom-larger"
            style={{ lineHeight: 1.5, maxWidth: 220 }}
          >
            We hit an unexpected error. Your data is safe — let's get you back
            on track.
          </div>
          <Button
            boxShadow={false}
            text="Take me back"
            onClick={this.props.onClick}
          />
          {this.props.onGetHelp && (
            <span
              className="font-size-small font-family-gilroy-medium font-color-primary margin-top-default cursor-pointer"
              style={{ textDecoration: "underline" }}
              onClick={this.props.onGetHelp}
            >
              Get help
            </span>
          )}
        </main>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
